export default __webpack_public_path__ + "static/media/kids-waiting-room.d5660af7.png";